export default __webpack_public_path__ + "static/media/Pickpocket's Helm of the Hidden Palace.3d1b01ce.jpg";